import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import SkeletonLoader from "../skeleton_loader";

interface LoadingProps {
  show: boolean;
}

const Loading: React.FC<LoadingProps> = ({ show }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={show}
    >
 <SkeletonLoader
                count={Math.floor(window.innerHeight / 40)}
                styles={{ height: 30, width: "100%" }}
              />    </Backdrop>
  );
};

export default Loading; 